<template>
  <div class="sidebar-container">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        router
        mode="vertical"
        :default-active="$route.path"
        :unique-opened="isUniqueOpened"
        background-color="#2e323f"
        text-color="#bfcbd9"
        active-text-color="#FFF"
      >
        <sidebar-item v-for="menu in menuList" :key="menu.id" :item="menu" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
import SidebarItem from "./SidebarItem";
export default {
  name: "Sidebar",
  components: { SidebarItem },
  props: {
    menuList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isUniqueOpened: true,
    };
  },
  computed: {
    // defaultActive() {
    //   if (this.menuList[0].children.length != 0) {
    //     return this.menuList[0].children[0].path;
    //   } else {
    //     return this.menuList[0].path;
    //   }
    // }
  },
};
</script>
<style lang="less">
.sidebar-container {
  transition: width 0.28s;
  width: 248px !important;
  height: 100%;
  font-size: 0px;
  bottom: 0;
  z-index: 1999;
  overflow: auto;

  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }
  .el-scrollbar {
    height: 100%;
  }
  .scrollbar-wrapper {
    overflow-x: hidden !important;
    .el-scrollbar__view {
      height: 100%;
    }
  }
  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }
  .is-horizontal {
    display: none;
  }
  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }
  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
  }
  .is-active {
    background-color: #5584ff !important;
  }
  .is-active > .el-submenu__title {
    color: #f4f4f5 !important;
  }
}
</style>